"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("../component");

var data_1 = require("../data");

var helper_1 = require("../helper");

var ProteinFeatureViewer =
/** @class */
function (_super) {
  __extends(ProteinFeatureViewer, _super);

  function ProteinFeatureViewer(props) {
    var _this = _super.call(this, props) || this;

    _this.onProteinInputChange = function (event, data) {
      _this.setState({
        proteinId: data.value
      });
    };

    _this.onProteinInputSubmit = function (event, data) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.deriveProteinData()];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.onShowGroupedChange = function (event, data) {
      _this.setState({
        showGrouped: data.checked !== undefined ? data.checked : _this.state.showGrouped
      });
    };

    _this.renderAnnotationText = function (proteinId, index) {
      var _a = _this.state,
          domainData = _a.domainData,
          protein = _a.protein;
      var pFamIds = protein ? protein.dbReferences.filter(function (dbRef) {
        return dbRef.type === 'Pfam';
      }).filter(function (pFamRef) {
        var properties = pFamRef.properties;
        var entryName = properties ? properties['entry name'] : null;
        return entryName && (entryName === proteinId || entryName.localeCompare(proteinId + "-like " + index));
      }) : [];
      return pFamIds.length >= 1 ? proteinId + ": " + proteinId + " domain (" + domainData[index].start + " - " + domainData[index].end + ")<br /><a href=\"http://pfam.xfam.org/family/" + pFamIds[0].id + "\">PFAM</a> <a href=\"http://mutationaligner.org/domains/" + pFamIds[0].id + "\">Mutagen Aligner</a>" : '';
    };

    _this.state = {
      data: [],
      domainData: [],
      proteinId: props.initialProteinId,
      showGrouped: true
    };
    return _this;
  }

  ProteinFeatureViewer.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.deriveProteinData()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ProteinFeatureViewer.prototype.render = function () {
    var _a = this.state,
        domainData = _a.domainData,
        protein = _a.protein,
        proteinId = _a.proteinId,
        showGrouped = _a.showGrouped;
    return React.createElement("div", {
      className: 'protein-feature-viewer'
    }, React.createElement(semantic_ui_react_1.GridRow, {
      centered: true,
      stretched: false
    }, React.createElement(semantic_ui_react_1.GridColumn, null, React.createElement(component_1.FeatureViewer, {
      data: domainData,
      getTextForHover: this.renderAnnotationText,
      title: protein ? protein.id : '',
      showGrouped: showGrouped
    })), React.createElement(semantic_ui_react_1.GridColumn, null, React.createElement(semantic_ui_react_1.Form, {
      onSubmit: this.onProteinInputSubmit
    }, React.createElement(semantic_ui_react_1.Form.Input, {
      onChange: this.onProteinInputChange,
      value: proteinId,
      fluid: false,
      width: 'three'
    }), React.createElement(semantic_ui_react_1.Form.Button, null, "Submit Protein ID"), React.createElement(semantic_ui_react_1.Form.Checkbox, {
      defaultChecked: true,
      label: 'Show grouped?',
      onChange: this.onShowGroupedChange
    })))));
  };

  ProteinFeatureViewer.prototype.deriveProteinData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var result, protein, domains, colorMapper_1, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);

            return [4
            /*yield*/
            , fetch("https://www.ebi.ac.uk/proteins/api/proteins/" + this.state.proteinId)];

          case 1:
            result = _a.sent();
            if (!(result && result.ok)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , result.json()];

          case 2:
            protein = _a.sent();
            domains = protein.features.filter(function (feature) {
              return feature.type === 'DOMAIN';
            });
            colorMapper_1 = new helper_1.ColorMapper();
            this.setState({
              domainData: domains.map(function (domain, index) {
                var begin = domain.begin,
                    _a = domain.description,
                    description = _a === void 0 ? '' : _a,
                    end = domain.end; // This matches domains that do and do not have other of the same domain in the protein.

                var domainName = description.split('-like')[0];
                return new data_1.TintedChell1DSection(domainName, begin ? Number.parseInt(begin, 10) : -1, end ? Number.parseInt(end, 10) : -1, colorMapper_1.getColorFor(domainName));
              }),
              protein: protein
            });
            _a.label = 3;

          case 3:
            return [3
            /*break*/
            , 5];

          case 4:
            e_1 = _a.sent();
            console.log(e_1);
            return [3
            /*break*/
            , 5];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ProteinFeatureViewer.defaultProps = {
    // initialProteinId: 'Q13485',
    initialProteinId: 'Q9NYJ7'
  };
  return ProteinFeatureViewer;
}(React.Component);

exports.ProteinFeatureViewer = ProteinFeatureViewer;